import React from "react";
import styles from './Loader.module.css';

const Loader = () => {
    return (
        <div >
            <div className={styles.loaderWrapper}>
                <div className={styles.loaderBall1}></div>
                <div className={styles.loaderBall2}></div>
                <div className={styles.loaderBal3}></div>
                <div className={styles.loaderBall4}></div>
                <div className={styles.loaderBall5}></div>
            </div>
        </div>
    );
};

export default Loader;
